export default __webpack_public_path__ + "static/media/Blade's Leggings of Charred Earth.2ff5395f.jpg";